// extracted by mini-css-extract-plugin
module.exports = {"charts":"charts__31DEX","loading":"loading__s-e3Y"};